function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import classnames from "classnames";
import TwoThirdsTextAndAssetComponent from "segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-component";
import colors from "styles/colors";
import { getUrlWithColor } from "services/community/cloudinary-service";
import { SM } from "constants/sizes";
import { StyledBuildingBlocksTabContentComponent } from "./building-blocks-tab-content-component.scss";
const BuildingBlocksTabContentComponent = (props)=>{
    const { tab, isSelected, themeColor, isAssetVisible, isMobileDisplay, displayTitle = true } = props;
    const getTextAndAssetProps = ()=>_object_spread_props(_object_spread({}, tab.textAndAsset), {
            hideControls: true,
            asset: isAssetVisible ? _object_spread_props(_object_spread({}, tab.textAndAsset.asset), {
                video: _object_spread_props(_object_spread({}, tab.textAndAsset.asset.video), {
                    videoPlayerRef: tab.videoPlayerRef
                })
            }) : {},
            fullParagraph: _object_spread_props(_object_spread({}, tab.textAndAsset.fullParagraph), {
                titleIcon: getUrlWithColor({
                    url: tab === null || tab === void 0 ? void 0 : tab.tabIcon,
                    color: colors[themeColor]
                }),
                titleColor: themeColor,
                titleSize: isMobileDisplay ? SM : tab.textAndAsset.fullParagraph.textSize,
                title: displayTitle ? tab.textAndAsset.fullParagraph.title : ""
            }),
            textSize: isMobileDisplay ? SM : tab.textAndAsset.fullParagraph.textSize
        });
    const textAndAssetProps = getTextAndAssetProps();
    return /*#__PURE__*/ _jsx(StyledBuildingBlocksTabContentComponent, {
        className: classnames("building-blocks-content-wrapper", {
            selected: isSelected
        }),
        children: /*#__PURE__*/ _jsx(TwoThirdsTextAndAssetComponent, _object_spread_props(_object_spread({}, textAndAssetProps), {
            useWindowMask: tab.textAndAsset.asset.useWindowMask
        }))
    });
};
BuildingBlocksTabContentComponent.defaultProps = {
    isSelected: true,
    isAssetVisible: true
};
export default BuildingBlocksTabContentComponent;
